module.exports = __webpack_public_path__ + "static/img/full.78c5295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/full.png
// module id = gz4F
// module chunks = 24